// ************************************************************************************************************************************************************
//
// CONFIDENTIAL
// Unpublished Work, Copyright 2023, Baxter Healthcare Corporation. All rights reserved.
// For use only by Baxter Healthcare Corporation.
// This document contains proprietary information. It must not be reproduced
// or disclosed to others without prior written approval.
//
// Filename: facilityCrud.js
// Description: This file is responsible for All API call for facility
//
// ************************************************************************************************************************************************************
import API from "../../../config/networkInterceptor";
export function addFacility(values, countryCode) {
  return API.post("v1/facilities ", {
    name: values.hospitalName,
    physical_address: values.physicalAddress,
    city: values.city,
    state: values.state,
    zip: values.zip,
    country_code: countryCode,
    timezone: values.timeZone,
    facility_id: values.facilityId,
    contact_name: values.facilityContactName,
    contact_email: values.email,
    contact_phone: values.phone,
    mca_rep_name: values.mcaRepName
  });
}
export function editFacility(values, countryCode, id) {
  let _id = id.toString();
  return API.put("v1/facilities/" + id, {
    id: _id,
    name: values.hospitalName,
    physical_address: values.physicalAddress,
    city: values.city,
    state: values.state,
    zip: values.zip,
    timezone: values.timeZone,
    country_code: countryCode,
    facility_id: values.facilityId,
    contact_name: values.facilityContactName,
    contact_email: values.email,
    contact_phone: values.phone,
    mca_rep_name: values.mcaRepName
  });
}
export function getFacility(count, page, sort_column, sort_order) {
  return API.get(
    "v1/facilities?count=" +
      count +
      "&page=" +
      page +
      "&sort_column=" +
      sort_column +
      "&sort_order=" +
      sort_order
  );
}
export function getFacilityAll(sort_column, sort_order) {
  return API.get(
    "v1/facilities?type=all" +
      "&sort_column=" +
      sort_column +
      "&sort_order=" +
      sort_order
  );
}

/*
==================================================================================
Created On : 25/10/2023
Purpose: Count API Implementation for Facility count
==================================================================================
*/
export function getFacilityAllCount() {
  return API.get("v1/facilities/count");
}
export function searchFacilityByName(name, count, page) {
  return API.post("v1/facilities/search?count=" + count + "&page=" + page, {
    name: name
  });
}
/*
==================================================================================
Created On : 9/11/2023
Purpose: Search facilities API Implementation
==================================================================================
*/
export function searchAllfacilities({
  searchValue,
  count,
  page,
  sort_column,
  sort_order
}) {
  return API.post(
    "v1/facilities/search?count=" +
      count +
      "&page=" +
      page +
      "&sort_column=" +
      sort_column +
      "&sort_order=" +
      sort_order,
    {
      searchValue
    }
  );
}

export function getFacilityDetailsById(id) {
  return API.get("v1/facilities/" + id);
}

/*
==================================================================================
Created On : 01/01/2024
Purpose: delete API Implementation for Facility
==================================================================================
*/

export function deleteFacility(forceDelete, facility_ids, skippedfacility_ids) {
  return API.delete(`v1/facilities/multiple/delete`, {
    data: {
      forceDelete: forceDelete,
      facility_ids: facility_ids,
      skippedfacility_ids: skippedfacility_ids
    }
  });
}
export function deleteSearchFacility(
  forceDelete,
  searchValue,
  facility_ids,
  skippedfacility_ids
) {
  return API.delete(`v1/facilities/multiple/delete/search`, {
    data: {
      forceDelete: forceDelete,
      searchValue: searchValue,
      facility_ids: facility_ids,
      skippedfacility_ids: skippedfacility_ids
    }
  });
}

/*
==================================================================================
Created On : 17/01/2024
Purpose: to get all Facility API Implementation for Facility
==================================================================================
*/

export function getAllFacilityNames(inputValue) {
  const postData = {
    search_name: inputValue
  };
  return API.post("v1/facilities/names", postData);
}